import React from 'react';

export function NormalColumnFormatter(cellContent) {

  return (
    <span className="text-dark-75 font-weight-bold d-block font-size-m">
      {cellContent}
    </span>
  );
}
